import { render, staticRenderFns } from "./coupon-user-discount.vue?vue&type=template&id=5429c980"
import script from "./coupon-user-discount.vue?vue&type=script&lang=js"
export * from "./coupon-user-discount.vue?vue&type=script&lang=js"
import style0 from "./coupon-user-discount.vue?vue&type=style&index=0&id=5429c980&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports